import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import {
  API_AUTH_PASSWORD,
  API_AUTH_USERNAME,
  API_BASE_URL,
  ADMIN_ID,
} from "../../Constant/Global";

const DashboardDataContext = createContext();

export const DashboardDataProvider = ({ children }) => {
  const [dashboardData, setDashboardData] = useState([]);
  const [bannerData, setBannerData] = useState([]);
  const [mobileBannerData, setMobileBannerData] = useState([]);
  const [otherData, setOtherData] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [imagesUrl, setImagesUrl] = useState([]);
  const [videosUrl, setVideosUrl] = useState([]);
  const [contactInfo, setContactInfo] = useState([]);
  const [socialLinks, setSocialLinks] = useState([]);

  const [fontSize, setFontSize] = useState(16);

  const increaseFontSize = () => {
    setFontSize((prevSize) => prevSize + 1);
  };

  const resetFontSize = () => {
    setFontSize(16); // Reset font size to default value
  };

  const decreaseFontSize = () => {
    setFontSize((prevSize) => prevSize - 1);
  };

  // dashboard api

  const handleDashboardData = async () => {
    try {
      const finalData = { admin_id: ADMIN_ID };
      const response = await axios.post(
        API_BASE_URL + "web/dashboard",
        finalData,
        {
          auth: {
            username: API_AUTH_USERNAME,
            password: API_AUTH_PASSWORD,
          },
        }
      );
      setIsLoading(false);
      console.table("dashboard response", response.data.data);
      setDashboardData(response.data.data);
      // images url
      const imageUrls = response.data.data.photo_video
        .filter((item) => item.type === "image")
        .map((item) => item.image);
      setImagesUrl(imageUrls);
      // videos url
      const videoUrls = response.data.data.photo_video
        .filter((item) => item.type === "url" && item.youtube_url)
        .map((item) => item.youtube_url);
      setVideosUrl(videoUrls);
      setOtherData(response.data.data.other_info);
      setBannerData(response.data.data.banner);
      setMobileBannerData(response.data.data.mobile_banner);
    } catch (error) {
      console.log(error.response);
    }
  };

  useEffect(() => {
    handleDashboardData();
  }, []);

  const handleContactData = async () => {
    try {
      const finalData = { admin_id: ADMIN_ID };
      // console.log("finalData", finalData);
      const response = await axios.post(
        API_BASE_URL + "web/contact_us",
        finalData,
        {
          auth: {
            username: API_AUTH_USERNAME,
            password: API_AUTH_PASSWORD,
          },
        }
      );
      setContactInfo(response.data.data);
    } catch (error) {
      console.log(error.response);
    }
  };

  useEffect(() => {
    handleContactData();
    handleSocialLinksData();
  }, []);

  const handleSocialLinksData = async () => {
    try {
      const finalData = { admin_id: ADMIN_ID };
      // console.log("finalData", finalData);
      const response = await axios.post(
        API_BASE_URL + "web/get_social_link",
        finalData,
        {
          auth: {
            username: API_AUTH_USERNAME,
            password: API_AUTH_PASSWORD,
          },
        }
      );
      console.log("social links data", response.data);
      setSocialLinks(response.data.data);
    } catch (error) {
      console.log(error.response);
    }
  };

  return (
    <DashboardDataContext.Provider
      value={{
        dashboardData,
        setDashboardData,
        bannerData,
        otherData,
        isLoading,
        imagesUrl,
        videosUrl,
        contactInfo,
        fontSize,
        increaseFontSize,
        resetFontSize,
        decreaseFontSize,
        socialLinks,
        mobileBannerData,
      }}
    >
      {children}
    </DashboardDataContext.Provider>
  );
};

export const useDashBoardData = () => {
  return useContext(DashboardDataContext);
};
export default DashboardDataContext;
